import React from "react"
import { Link } from "gatsby"
import partner_badge_banner from "../../images/partner_badge_banner.svg"
import partner_chevron_banner from "../../images/partner_chevron_banner.svg"

function Banner() {
  return (
    <Link
      to="https://cognetiks.com/blog/d05b9750-f3e5-55aa-adbf-14ac0573d20f/"
      className="mb-10 hover:opacity-80 w-[400px] md:w-[500px] xl:w-[730px] quicksand border bg-[#ECECF9] rounded-full inline-block px-3 py-1 items-center mx-auto flex justify-center gap-4"
    >
      <img src={partner_badge_banner} alt="" />
      <div className="text-[11px] md:text-md xl:text-[20px] font-semibold bg-gradient-to-b from-[#8900C8]  to-[#DFA101] text-transparent bg-clip-text">
        2024 AWS EMEA Rising Star Consulting Partner of the Year
      </div>
      <span className="-mx-2">🎉</span>
      <img src={partner_chevron_banner} alt="" />{" "}
    </Link>
  )
}

export default Banner
